import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  TableContainer,
  Grid, 
  useMediaQuery,
  Table, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination,
  Box,
  Chip,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Paper
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Iconify from '../../../layouts/Iconify';
import Scrollbar from '../../../layouts/Scrollbar';
import { UserListHead, UserListToolbar } from '../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../layouts/user/MiscSkeleton';
import { GetAll, apiURL } from '../../../utils/apiCalls';
import { filter } from 'lodash';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CategoryIcon from '@mui/icons-material/Category';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { capitalCase } from 'change-case';
import SearchNotFound from '../../../layouts/SearchNotFound';
import GridAds from '../../../components/ads/GridAds';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'no', label: 'SNo.', align: 'left' },
  { id: 'name', label: 'Project Name', align: 'left' },
  { id: 'place', label: 'Place', align: 'left' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: '', label: '', align: 'center' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        JSON.stringify(_user['name'])
          .toLowerCase()
          .trim()
          .indexOf(query.toLowerCase().trim()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

// ----------------------------------------------------------------------

const AgentProjectList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState();
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  async function GetList() {
    setLoading(true);
    const response = await GetAll(apiURL + '/api/v1/projects');
    if (response) {
      if (response.data.status) {
        setList(response.data.data);
      } else {
        toast.error(response.data.message);
        setList([]);
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    GetList();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterByName = (event) => setFilterName(event.target.value);

  const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);
  const isUserNotFound = filteredUsers.length === 0;

  const handleClickEdit = (e, id) => navigate(`/dashboard/projectAgent/${id}`);

  return (
    <Container sx={{ m: 0, width: '100%', maxWidth: '100%' }} maxWidth={false}>

      {/* Professional Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 0}}>
          <Box sx={{ mb: 1 }}>
        <GridAds positionId={3} rows={1} />
        </Box>
          <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
            <Avatar
              sx={{
                bgcolor: '#1976d2',
                width: 48,
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
              }}
            >
              <BusinessIcon sx={{ fontSize: 24, color: 'white' }} />
            </Avatar>
            <Box>
              <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
                Project Management
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Manage and track all your projects efficiently
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      {/* Grid Ads - One Row */}


      <Zoom in timeout={1000}>
        <Card
          elevation={4}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          }}
        >
          {/* Toolbar Section */}
          <Box
            sx={{
              p: 3,
              backgroundColor: '#f8f9fa',
              borderBottom: '1px solid #e9ecef',
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <UserListToolbar
                  placeholder="Search by Project Name"
                  numSelected={selected.length}
                  filterName={filterName}
                  onFilterName={handleFilterByName}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  justifyContent: isMobile ? 'center' : 'flex-end',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => navigate('/dashboard/CustomProjectPay')}
                  sx={{
                    height: 'max-content',
                    marginRight: '24px !important',
                    marginBottom: '15px !important',
                    width: isMobile ? '80%' : 'max-content',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#1565c0' },
                    borderRadius: 2,
                    px: 3,
                    py: 1.5,
                    fontWeight: 'bold',
                  }}
                  startIcon={<Iconify icon="mdi:credit-card" />}
                >
                  Custom Pay
                </Button>
              </Grid>
            </Grid>
          </Box>

          {/* Table Section */}
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table stickyHeader>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={list.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                isCheckbox={false}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const { id, name, place, type } = row;
                    return (
                      <TableRow
                        hover
                        key={id}
                        onClick={(e) => handleClickEdit(e, id)}
                        sx={{
                          cursor: 'pointer',
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            backgroundColor: '#f8f9fa',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          },
                        }}
                      >
                        <TableCell align="left">
                          <Chip
                            label={index + 1}
                            size="small"
                            sx={{
                              backgroundColor: '#1976d2',
                              color: 'white',
                              fontWeight: 'bold',
                            }}
                          />
                        </TableCell>
                        <TableCell align="left" sx={{ color: '#1976d2', fontWeight: '600' }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <BusinessIcon sx={{ fontSize: 16, color: '#1976d2' }} />
                            <Typography variant="body2" fontWeight="600">
                              {capitalCase(name)}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <LocationOnIcon sx={{ fontSize: 16, color: '#6c757d' }} />
                            <Typography variant="body2" color="text.secondary">
                              {place}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={type}
                            size="small"
                            variant="outlined"
                            sx={{
                              borderColor: '#1976d2',
                              color: '#1976d2',
                              fontWeight: '500',
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="View Project Details">
                            <IconButton
                              color="primary"
                              onClick={(e) => handleClickEdit(e, id)}
                              sx={{
                                backgroundColor: '#1976d2',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#1565c0',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s ease-in-out',
                              }}
                            >
                              <VisibilityIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {isUserNotFound && (
                  <TableBody>
                    {loading ? (
                      <MiscSkeleton record={{ number: 7 }} />
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                          {list.length <= 0 ? (
                            <Typography gutterBottom align="center" variant="subtitle1">
                              Not found
                            </Typography>
                          ) : (
                            <SearchNotFound searchQuery={filterName} />
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              borderTop: '1px solid #e9ecef',
              backgroundColor: '#f8f9fa',
            }}
          />
        </Card>
      </Zoom>

      {/* Professional Stats Footer */}
      <Fade in timeout={1200}>
        <Box sx={{ mt: 4 }}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderRadius: 3,
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ bgcolor: '#1976d2', width: 40, height: 40 }}>
                    <BusinessIcon sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {list.length}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Projects
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ bgcolor: '#28a745', width: 40, height: 40 }}>
                    <CategoryIcon sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {new Set(list.map((item) => item.type)).size}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Project Types
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar sx={{ bgcolor: '#ffc107', width: 40, height: 40 }}>
                    <LocationOnIcon sx={{ fontSize: 20 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      {new Set(list.map((item) => item.place)).size}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Locations
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Fade>
    </Container>
  );
};

export default AgentProjectList;
